import { useEffect, useState } from 'react';
import axios from 'axios';

// VIP daily limits set in the admin AI controls (0 = no limit), used in user-facing texts
let cache = null;
const load = () => {
  if (!cache) {
    cache = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/ai/public-limits`)
      .then((r) => r.data).catch(() => { cache = null; return null; });
  }
  return cache;
};

export const useVipLimits = () => {
  const [limits, setLimits] = useState(null);
  useEffect(() => { let on = true; load().then((d) => on && d && setLimits(d)); return () => { on = false; }; }, []);
  return limits;
};

// "fino a N volte al giorno" / "senza limiti"
export const vipTimesText = (n) => (n ? `fino a ${n} volte al giorno` : 'senza limiti');

export const vipFeatureText = (n) => `Con il VIP puoi usare questa funzione ${vipTimesText(n)}. Scopri cosa sblocchi con le selezioni di Vincenzo.`;
